import { RefreshOutlined } from '@teko/ds-icon';
import { Button, Col, Container, Row, styled } from '@teko/ds-mobile';
import { trackCustomEvent } from '@teko/tracking';
import { isEmptyObject } from '@teko/utils';
import { useHamper, useTenantConfig } from 'contexts';
import { t } from 'i18n';
import { useMemo, useState } from 'react';
import { IHamperItemData } from 'types';
import { HamperItem, HamperSummary, HamperTabs } from './components';
import { HamperModalMobile } from './components/HamperModal';

export const CustomHamper = () => {
  const [selectedBomItem, setSelectedBomItem] =
    useState<NonNullable<typeof bomMapping>[string]>();

  const { bomMapping } = useTenantConfig();

  const {
    hamperData,
    changeActiveConfig,
    updateCurrentConfig,
    currentHamperConfig,
    hamperDetailProducts,
    increaseHamperItemQuantity,
    removeHamperItem,
    decreaseHamperItemQuantity,
    setHamperItemQuantity,
  } = useHamper();

  const bomMappingKeys = useMemo(() => {
    return !!bomMapping && !isEmptyObject(bomMapping)
      ? Object.keys(bomMapping)
      : [];
  }, [bomMapping]);

  const onClickBomItem = (
    hamperItem: NonNullable<typeof bomMapping>[string],
  ) => {
    setSelectedBomItem(hamperItem);
  };

  if (isEmptyObject(bomMapping) || !bomMapping) {
    return null;
  }

  return (
    <Container padding="s16" width="100%" id="hamper-item-block">
      <HamperTabs
        lsActiveTab={hamperData.activeIndex}
        onClickTab={(index) => {
          changeActiveConfig(index);
          trackCustomEvent('changeHamperConfig', {
            action: 'click',
            category: 'custom_hamper',
            value: index + 1,
          });
        }}
      />
      <Row marginTop="s16" justify="end">
        <Button variant="primary" onClick={() => updateCurrentConfig({})}>
          {t('Tạo lại')}
          <RefreshOutlined
            color="white"
            size={16}
            style={{ marginLeft: '0.5rem' }}
          />
        </Button>
      </Row>
      <Col marginTop="s16">
        {bomMappingKeys.map((customHamper) => {
          const selectedHamper =
            (currentHamperConfig[customHamper] as IHamperItemData[]) || [];
          const hampers = hamperDetailProducts.products
            .filter((hamper) => {
              return selectedHamper.map((p) => p.sku).includes(hamper.sku);
            })
            .map((p) => {
              return {
                ...p,
                quantity:
                  selectedHamper.find((h) => h.sku === p.sku)?.quantity || 1,
              };
            });
          return (
            <StyledHamperItem
              key={bomMapping?.[customHamper]?.type}
              title={bomMapping?.[customHamper]?.name}
              icon={bomMapping[customHamper].icon}
              products={!!hampers && !!Array.isArray(hampers) ? hampers : []}
              onIncrease={(sku: string) =>
                increaseHamperItemQuantity(customHamper, sku)
              }
              onDecrease={(sku, quantity) => {
                quantity === 1
                  ? removeHamperItem(customHamper, sku)
                  : decreaseHamperItemQuantity(customHamper, sku);
              }}
              setQuantity={(value, sku) => {
                setHamperItemQuantity(customHamper, value, sku);
              }}
              removeItem={(sku) => removeHamperItem(customHamper, sku)}
              onClick={() => onClickBomItem(bomMapping?.[customHamper])}
            />
          );
        })}
      </Col>
      <HamperSummary />

      <HamperModalMobile
        collectionSlug={selectedBomItem?.slug || ''}
        visible={!!selectedBomItem}
        onClose={() => setSelectedBomItem(undefined)}
        hamperItemKey={selectedBomItem?.type || ''}
      />
    </Container>
  );
};

const StyledHamperItem = styled(HamperItem)`
  margin-bottom: 1rem;
`;
